module.exports = __webpack_public_path__ + "img/zhyj-4.979e9943.png";